import type { FlexCostCode, FlexCode, FlexGlCode } from 'API';
import CodingEntityDropdown from 'app/pages/overview/tabs/transactions/CodingEntityDropdown';

interface FlexCostCodeDropdownProps {
  selectedGlCode?: FlexGlCode | null;
  selectedProject?: FlexCode | null;
  selectedCostCode?: FlexCostCode | null;
  onValueChange: (option: FlexCostCode | null) => void;
  disabled?: boolean;
  disableHeader?: boolean;
  placeholder?: string | null;
}

const FlexCostCodeDropdown = ({
  selectedCostCode,
  selectedGlCode,
  selectedProject,
  onValueChange,
  disabled,
  disableHeader = false,
}: FlexCostCodeDropdownProps) => {
  return (
    <CodingEntityDropdown<FlexCostCode>
      erpType="flex"
      entityType="costCodes"
      selectedItem={selectedCostCode}
      selectedGlCode={selectedGlCode}
      selectedProject={selectedProject}
      onValueChange={onValueChange}
      disabled={disabled}
      disableHeader={disableHeader}
    />
  );
};

export default FlexCostCodeDropdown;
